export default __webpack_public_path__ + "static/jokingLaughing-54a933387de3cf32e86401f2768af799.svg";